module.exports = __webpack_public_path__ + "static/media/atomizer-1.55f76c3c.jpg";